import {useStoreService} from '../../service/store/index'
import { IStore } from "../../utils/interfaces/IStore";

const useCreateStore = () => {
    const {createStore} = useStoreService()
  const createStoreHooks = async (data: IStore) => {
     await createStore(data)
  };
  return {
    createStoreHooks,
  };
};

export default useCreateStore;
